<template>
    <div>
        <v-dialog v-model="dialog" persistent max-width="800px">
            <v-card>
                <v-form>
                    <v-toolbar flat dense>
                        <v-toolbar-title class="subheading">Policy Acknowledgements</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="onCancelClick">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>

                    <v-divider></v-divider>
                    <v-data-table :headers="headers" :items="agreements" hide-actions class="elevation-1">
                            <template slot="items" slot-scope="props">
                                <tr>
                                    <td class="text-xs-left" style="white-space:nowrap;">
                                        <v-avatar size="30px">
                                            <img :src="getAvatar(props.item.employee.id)" class="avatar-img" />
                                        </v-avatar>
                                        <router-link class="ml-3" :to="{ name: 'employee', params: { id: props.item.employee.id } }">{{ props.item.employee.fullName }}</router-link>							
                                    </td>
                                    <td class="text-xs-left" style="white-space:nowrap;">
                                        <AppDate :date="props.item.agreementDateUtc" show-date format="Do MMM YYYY, HH:mm" />									
                                    </td>
                                    <td class="text-xs-left">
                                        <TextSnippet :value="props.item.acknowledgementText" :snippet-length="40" class="py-2" />			
                                    </td>
                                </tr>
                            </template>
                            <template v-slot:no-data>
							    No employees have acknowledged this policy
						    </template>
                        </v-data-table>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn flat @click="onCancelClick">Cancel</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import avatarMixin from '@/mixins/avatarMixin';
import TextSnippet from '@/components/common/TextSnippet'

export default {
    components: {
        TextSnippet
    },
    props: {
        dialog: {
            required: true
        },
        agreements: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            headers: [
                    { text: 'Employee', value: 'name' },
                    { text: 'Acknowledged at', value: 'acknowledged', sortable: false },
                    { text: 'Acknowledgement', value: 'acknowledgement', sortable: false },
                ],
        }
    },
    mixins: [avatarMixin],
    computed: {

    },
    methods: {
        onCancelClick() {
            this.$emit('onCancel');
        }

    }
}
</script>

<style scoped>
    .disclaimer {
        color: rgba(0, 0, 0, 0.54);
		font-size: 12px !important;
    }
</style>